import Vue from "vue";
import Vuex from "vuex";
import { Auth, DataStore } from "aws-amplify";
// import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isOnline: true,
    appLoading: false,
    userSignedIn: false,
    fetchedUserGroups: false,
    userGroups: null,
    userEmail: "",
    syncedTeacherProfile: false,
    syncedTeacherProfileModel: null,
    teacherProfileID: "",
    teacherProfileProvince: "",
    teacherProfileSchoolID: "",
    teacherProfilePayfastSubscriptionToken: "",
    teacherProfilePayfastSubscriptionResponse: null,
    teacherProfileAppSyncVersion: "",
    notReadAnnouncements: null,

    syncedTeacherProductsOrders: false,
    syncedTeacherProductsOrderModels: [],

    syncedPendingTeacherProductsOrder: null,
    syncedBoughtProducts: [],
    syncedPendingProducts: [],

    datastorePredicates: [],
    datastoreSubscriptions: [],
    changingDatastoreConfig: false,
    datastoreReady: false,
    startedDatastoreSync: false,

    productBundleParams: null,
    // teacherProfilePayfastSubscriptionPackage: null,
    // teacherProfileProductSubcriptions: 50,
  },
  getters: {
    subscriptionExists: (state) => (model) => {
      return state.datastoreSubscriptions.some((item) => item.model === model);
    },
  },
  mutations: {
    changeProductBundleParams(state, payload) {
      state.productBundleParams = payload;
    },

    addSubscriptions(state, subscriptions) {
      state.startedDatastoreSync = true;

      state.datastoreSubscriptions.push(...subscriptions);

      // console.log(
      //   "addSubscriptions",
      //   JSON.stringify(state.datastoreSubscriptions.map((item) => item.model))
      // );
    },

    addSubscription(state, subscription) {
      state.startedDatastoreSync = true;

      state.datastoreSubscriptions.push(subscription);

      // console.log(
      //   "addSubscription",
      //   JSON.stringify(state.datastoreSubscriptions.map((item) => item.model))
      // );
    },

    removeSubscriptions(state, subscriptionsToRemove) {
      try {
        for (const subModel of subscriptionsToRemove) {
          const subscriptionIndex = state.datastoreSubscriptions.findIndex(
            (item) => item.model === subModel
          );
          if (subscriptionIndex !== -1) {
            state.datastoreSubscriptions[subscriptionIndex].sub.unsubscribe();
            state.datastoreSubscriptions.splice(subscriptionIndex, 1);
          }
        }

        // console.log(
        //   "removeSubscriptions",
        //   JSON.stringify(state.datastoreSubscriptions)
        // );

        clearSubscribedTeacherData(state);
      } catch (error) {
        console.log("removeSubscriptions error: ", error);
      }
    },

    clearSubscriptions(state) {
      try {
        for (const subscription of state.datastoreSubscriptions) {
          subscription.sub.unsubscribe();
        }

        state.datastoreSubscriptions = [];
        // console.log(
        //   "clearSubscriptions",
        //   JSON.stringify(state.datastoreSubscriptions)
        // );

        clearSubscribedTeacherData(state);
      } catch (error) {
        console.log("clearSubscriptions error: ", error);
      }
    },

    storeDatastoreReady(state, payload) {
      // console.log("storeDatastoreReady vuex", payload);
      state.datastoreReady = payload;
    },

    changingDatastoreConfig(state, payload) {
      // console.log("changingDatastoreConfig vuex", payload);
      state.changingDatastoreConfig = payload;
    },

    removeDatastorePredicates(state, predicatesToRemove) {
      try {
        for (const predicateModel of predicatesToRemove) {
          // Check if active subscriptions exist for the model
          if (
            state.datastoreSubscriptions.some((item) =>
              item.model.includes(predicateModel)
            )
          ) {
            continue;
          }

          const predicateIndex = state.datastorePredicates.findIndex(
            (item) => item.model === predicateModel
          );
          if (predicateIndex !== -1) {
            state.datastorePredicates.splice(predicateIndex, 1);
          }
        }

        // console.log(
        //   "removeDatastorePredicates",
        //   JSON.stringify(state.datastorePredicates)
        // );
      } catch (error) {
        console.log("removeDatastorePredicates error: ", error);
      }
    },

    changeDatastorePredicates(state, predicatesToAdd) {
      try {
        for (const predicate of predicatesToAdd) {
          const predicateIndex = state.datastorePredicates.findIndex(
            (item) => item.model === predicate.model
          );
          if (predicateIndex !== -1) {
            if (!predicate.predicateVariables) {
              const incomingPredicateRole = predicate.predicate; // Assuming this is the incoming role
              const localPredicateRole =
                state.datastorePredicates[predicateIndex].predicate;

              if (
                (localPredicateRole === "Teacher" &&
                  incomingPredicateRole === "Admin") ||
                (localPredicateRole === "Teacher" &&
                  incomingPredicateRole === "SuperAdmin") ||
                (localPredicateRole === "Admin" &&
                  incomingPredicateRole === "SuperAdmin")
              ) {
                state.datastorePredicates[predicateIndex].predicate =
                  incomingPredicateRole;
              }

              state.datastorePredicates[predicateIndex].predicate =
                predicate.predicate;

              if (
                state.datastorePredicates[predicateIndex].predicateVariables
              ) {
                delete state.datastorePredicates[predicateIndex]
                  .predicateVariables;
              }
            } else {
              state.datastorePredicates[predicateIndex].predicate =
                predicate.predicate;

              state.datastorePredicates[predicateIndex].predicateVariables =
                predicate.predicateVariables;
            }
          } else {
            let newPredicate = {
              model: predicate.model,
              predicate: predicate.predicate,
            };

            if (predicate.predicateVariables) {
              newPredicate.predicateVariables = predicate.predicateVariables;
            }

            state.datastorePredicates.push(newPredicate);
          }
        }

        // console.log(
        //   "changeDatastorePredicates",
        //   JSON.stringify(state.datastorePredicates)
        // );
      } catch (error) {
        console.log("changeDatastorePredicates error: ", error);
      }
    },

    changeDatastorePredicate(state, payload) {
      const { model, predicate, predicateVariables } = payload;
      // Find model in state.datastorePredicates to update predicate:
      const modelIndex = state.datastorePredicates.findIndex(
        (item) => item.model === model
        //  && item.predicate === predicate
      );
      if (modelIndex !== -1) {
        if (!predicateVariables) {
          // state.datastorePredicates.splice(modelIndex, 1);

          state.datastorePredicates[modelIndex].predicate = predicate;
          if (state.datastorePredicates[modelIndex].predicateVariables)
            delete state.datastorePredicates[modelIndex].predicateVariables;
        } else {
          state.datastorePredicates[modelIndex].predicate = predicate;
          state.datastorePredicates[modelIndex].predicateVariables =
            predicateVariables;
        }
      }
      //  if (predicateVariables)
      else {
        let newPredicate = {
          model,
          predicate,
        };

        if (predicateVariables) {
          newPredicate.predicateVariables = predicateVariables;
        }

        state.datastorePredicates.push(newPredicate);
      }

      // console.log(
      //   "changeDatastorePredicate JSON.stringify(state.datastorePredicates)",
      //   JSON.stringify(state.datastorePredicates)
      // );
    },

    storeSyncedTeacherProductsOrders(state, payload) {
      // console.log('storeTeacherProfileModel', payload)
      state.syncedTeacherProductsOrders = payload;
    },

    storeTeacherProductsOrderModels(state, payload) {
      state.syncedTeacherProductsOrderModels = payload;

      const boughtProducts =
        payload?.length > 0
          ? payload
              .filter((order) => order?.orderStatus === "PAID") // Keep only "PAID" orders
              .flatMap((order) => order?.orderProducts || []) // Flatten orderProducts
              .flatMap((product) => {
                // Collect product's own ID
                const ids = [product?.id];

                // If product has a .products array with items, collect their IDs too
                if (
                  Array.isArray(product?.products) &&
                  product.products.length > 0
                ) {
                  ids.push(...product.products.map((p) => p?.id));
                }

                return ids;
              })
          : [];

      state.syncedBoughtProducts = boughtProducts;
    },

    storePendingTeacherProductsOrder(state, payload) {
      const pendingTeacherProductsOrder = (() => {
        if (!Array.isArray(payload)) {
          return payload;
        }

        if (!payload?.length) return null;

        // Find the first order with status "QUOTING"
        const quotingOrder = payload.find(
          (order) => order?.orderStatus === "QUOTING"
        );
        if (quotingOrder) {
          return quotingOrder;
        }

        // If no "QUOTING" order, find the first order with status "PENDING"
        const pendingOrder = payload.find(
          (order) => order?.orderStatus === "PENDING"
        );
        if (pendingOrder) {
          return pendingOrder;
        }

        return null;
      })();

      // console.log("pendingTeacherProductsOrder", pendingTeacherProductsOrder);

      const pendingProducts = (() => {
        if (!pendingTeacherProductsOrder) return [];

        return (
          pendingTeacherProductsOrder.orderProducts?.map(
            (product) => product?.id
          ) || []
        );
      })();

      state.syncedPendingTeacherProductsOrder = pendingTeacherProductsOrder;

      state.syncedPendingProducts = pendingProducts;
    },

    storeNotReadAnnouncements(state, payload) {
      state.notReadAnnouncements = payload;
    },

    storeIsOnline(state, payload) {
      if (state.isOnline !== payload) state.isOnline = payload;
    },

    storeUserGroups(state, payload) {
      state.userGroups = payload;
      state.fetchedUserGroups = true;
      // console.log("storeUserGroups", payload);
    },

    storeAppLoading(state, payload) {
      state.appLoading = payload;
    },

    storeUserSignedIn(state, payload) {
      state.userSignedIn = payload;
    },

    storeUserEmail(state, payload) {
      // console.log('storeUserEmail', payload)
      state.userEmail = payload;
    },

    storeSyncedTeacherProfile(state, payload) {
      // console.log('storeTeacherProfileModel', payload)
      state.syncedTeacherProfile = payload;
    },

    storeTeacherProfileModel(state, payload) {
      // console.log('storeTeacherProfileModel', payload)
      state.syncedTeacherProfileModel = payload;
      // console.log("storeTeacherProfileModel", payload);
    },

    storeTeacherProfileID(state, payload) {
      // console.log('storeTeacherProfileID', payload)
      state.teacherProfileID = payload;
    },

    storeTeacherProfilePayfastSubscriptionToken(state, payload) {
      // console.log('storeTeacherProfilePayfastSubscriptionToken', payload)
      state.teacherProfilePayfastSubscriptionToken = payload;
    },

    storeTeacherProfilePayfastSubscriptionResponse(state, payload) {
      // console.log('storeTeacherProfilePayfastSubscriptionResponse', payload)
      state.teacherProfilePayfastSubscriptionResponse = payload;
    },

    storeTeacherProfileAppSyncVersion(state, payload) {
      // console.log('storeTeacherProfileAppSyncVersion', payload)
      state.teacherProfileAppSyncVersion = payload;
    },

    storeTeacherProfileProvince(state, payload) {
      // console.log('storeTeacherProfileProvince', payload)
      state.teacherProfileProvince = payload;
    },

    storeTeacherProfileSchoolID(state, payload) {
      // console.log('storeTeacherProfileSchoolID', payload)
      state.teacherProfileSchoolID = payload;
    },
    // storeTeacherProfilePayfastSubscriptionPackage(state, payload) {
    //   // console.log('storeTeacherProfilePayfastSubscriptionPackage', payload)
    //   state.teacherProfilePayfastSubscriptionPackage = payload
    // },
    // storeTeacherProfileProductSubcriptions(state, payload) {
    //   // console.log('storeTeacherProfileProductSubcriptions', payload)
    //   state.teacherProfileProductSubcriptions = payload
    // }
  },
  actions: {
    async clearSubscriptions({ state }) {
      try {
        // Unsubscribe from all subscriptions
        const unsubscribePromises = state.datastoreSubscriptions.map(
          (subscription) =>
            new Promise((resolve) => {
              try {
                subscription.sub.unsubscribe();
                resolve(); // Assume success unless error is thrown
              } catch (error) {
                console.error("Error unsubscribing:", error);
                resolve(); // Resolve anyway to avoid hanging
              }
            })
        );

        // Wait for all unsubscriptions to complete
        await Promise.all(unsubscribePromises);

        state.datastoreSubscriptions = [];
        clearSubscribedTeacherData(state);

        // console.log("All subscriptions cleared");
      } catch (error) {
        console.error("clearSubscriptions action error:", error);
        throw error; // Let the caller handle errors
      }
    },

    storeSyncedTeacherProductsOrderModels({ commit }, payload) {
      commit("storeTeacherProductsOrderModels", payload);
      // if (!this.state.syncedPendingTeacherProductsOrder) {
      commit("storePendingTeacherProductsOrder", payload);
      // }
    },

    async signOut() {
      await DataStore.stop().catch(() =>
        // error
        {
          // console.log("error:", error);
        }
      );
      await Auth.signOut().catch(() =>
        // error
        {
          // console.log("error:", error);
        }
      );
      await DataStore.clear().catch(() =>
        // error
        {
          // console.log("error:", error);
        }
      );

      this.commit("storeUserSignedIn", false);
      this.commit("storeUserGroups", null);
      this.commit("storeUserEmail", "");
      this.commit("storeTeacherProfileModel", null);
      this.commit("storeSyncedTeacherProfile", false);
      this.commit("storeSyncedTeacherProductsOrders", false);
      this.commit("storeTeacherProductsOrderModels", []);
      this.commit("storeTeacherProfileID", "");
      this.commit("storeTeacherProfileProvince", "");
      this.commit("storeTeacherProfileSchoolID", "");
      this.commit("storeTeacherProfilePayfastSubscriptionToken", "");
      this.commit("storeTeacherProfilePayfastSubscriptionResponse", "");
      this.commit("storeTeacherProfileAppSyncVersion", "");
      this.commit("storeNotReadAnnouncements", null);

      // if (router.currentRoute.path !== '/') {
      //   router.push({ path: '/' })
      // }

      window.location.href = "/";
    },
  },
  modules: {},
});

//Helper functions

function clearSubscribedTeacherData(state) {
  const doesTeacherSubExist = state.datastoreSubscriptions.some((item) =>
    item.model.includes("TeacherProfile")
  );

  if (!doesTeacherSubExist) {
    // console.log("clearSubscribedTeacherData");
    state.syncedTeacherProfile = false;
    state.syncedTeacherProfileModel = null;
    state.teacherProfileID = "";
    state.teacherProfileProvince = "";
    state.teacherProfileSchoolID = "";
    state.teacherProfilePayfastSubscriptionToken = "";
    state.teacherProfilePayfastSubscriptionResponse = null;
    state.teacherProfileAppSyncVersion = "";
  }
}
